(function(){
    'use strict'

    angular
    .module('app.periodos')
    .controller('EditarPeriodo', EditarPeriodo);

    EditarPeriodo.$inject = ['$scope', '$animationsSrv', '$routeParams', 'PeriodosService', 'logger', '$location', 'UserInfoService'];

    function EditarPeriodo($scope, $animationsSrv, $routeParams, PeriodosService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.periodo;

        var periodoId = $routeParams.id ? $routeParams.id : 0;

        getPeriodo();

        function getPeriodo(){

            if(periodoId != 0){
                var promise = PeriodosService.getById(UserInfoService.getCompaniaId(), periodoId);

                promise
                .then(function(periodo){
                    vm.periodo = periodo;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener el período: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        vm.save = function(){

            $scope.submitted = true;

            if($scope.periodoForm.$valid){
                if(!vm.periodo.id){
                    savePeriodo();
                }
                else if($scope.periodoForm.$dirty){
                    updatePeriodo();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function savePeriodo() {
            var promise = PeriodosService.save(vm.periodo);
            
            promise
            .then(function(response){
                logger.success('Período creado con éxito.');
                clearPeriodoData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el período: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updatePeriodo(){
            var promise = PeriodosService.update(vm.periodo);
            
            promise
            .then(function(response){
                logger.success('Período modificado con éxito.');
                $location.path('/periodos');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el período: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearPeriodoData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.periodo = {};
            // Set back to pristine.
            $scope.periodoForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.periodoForm.$setUntouched();
        };

    }
})();